// RC9: the in-progress "Receive delivery" form, scoped to user + organisation + site. Kept in localStorage so
// a native app that iOS/Android suspends or kills in the background still has the photo ids, the extraction
// job, partial results and the chef's corrections on relaunch. Expires with the server job (24h). Cleared on
// save, on Discard and on logout. Not a general draft system.
const PREFIX = "cc_delivery_draft:";
export const DRAFT_TTL_MS = 24 * 3600 * 1000;

const store = () => { try { return window.localStorage; } catch { return null; } };

export function deliveryDraftKey(user, siteId) {
  if (!user?.user_id || !user?.org_id) return null;
  return `${PREFIX}${user.org_id}:${user.user_id}:${siteId || "all"}`;
}

export function loadDraft(key) {
  const s = store();
  if (!key || !s) return null;
  try {
    const d = JSON.parse(s.getItem(key) || sessionStorage.getItem(key) || "null");
    if (d && d.saved_at && Date.now() - d.saved_at > DRAFT_TTL_MS) { clearDraft(key); return null; }
    return d;
  } catch { return null; }
}

export function saveDraft(key, draft) {
  const s = store();
  if (key && s) {
    try { s.setItem(key, JSON.stringify({ ...draft, saved_at: Date.now() })); } catch { /* storage full/unavailable */ }
  }
}

export function clearDraft(key) {
  if (!key) return;
  try { store()?.removeItem(key); sessionStorage.removeItem(key); } catch { /* storage unavailable */ }
}

export function clearAllDeliveryDrafts() {
  for (const s of [store(), (() => { try { return sessionStorage; } catch { return null; } })()]) {
    try { Object.keys(s || {}).filter((k) => k.startsWith(PREFIX)).forEach((k) => s.removeItem(k)); } catch { /* unavailable */ }
  }
}

// On sign-in: drop drafts left by any OTHER account on this device (e.g. after a session expiry without
// logout) and any expired ones, so another person's photos/job ids/corrections are never kept around.
export function pruneDeliveryDrafts(user) {
  const mine = user?.user_id && user?.org_id ? `${PREFIX}${user.org_id}:${user.user_id}:` : null;
  const s = store();
  try {
    Object.keys(s || {}).filter((k) => k.startsWith(PREFIX)).forEach((k) => {
      if (!mine || !k.startsWith(mine)) s.removeItem(k);
      else loadDraft(k); // removes it if expired
    });
  } catch { /* storage unavailable */ }
  try { Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => sessionStorage.removeItem(k)); } catch { /* legacy tab-only drafts */ }
}
